  (function() {
    var wrap = document.currentScript.previousElementSibling;
    if (!wrap || !wrap.classList.contains('cm-countdown-pill')) return;

    var endAttr = wrap.getAttribute('data-countdown-end');
    if (!endAttr) return;

    var endTime = new Date(endAttr).getTime();
    if (isNaN(endTime)) return;

    var dEl = wrap.querySelector('[data-pill-days]');
    var hEl = wrap.querySelector('[data-pill-hours]');
    var mEl = wrap.querySelector('[data-pill-minutes]');
    var sEl = wrap.querySelector('[data-pill-seconds]');

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function tick() {
      var now  = Date.now();
      var diff = endTime - now;

      if (diff <= 0) {
        wrap.style.display = 'none';
        clearInterval(timer);
        return;
      }

      var seconds = Math.floor(diff / 1000);
      var days    = Math.floor(seconds / 86400);
      seconds    -= days * 86400;
      var hours   = Math.floor(seconds / 3600);
      seconds    -= hours * 3600;
      var minutes = Math.floor(seconds / 60);
      seconds    -= minutes * 60;

      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(minutes);
      if (sEl) sEl.textContent = pad(seconds);
    }

    tick();
    var timer = setInterval(tick, 1000);
  })();